import React from 'react';

import {backArrow} from './backArrow';
import {useHistory} from 'react-router';
import styles from './BackNavigation.module.scss';
import SubtleButton from '../../../../../SubtleButton';

export default function BackNavigation() {
  const history = useHistory();

  return (
    <SubtleButton onClick={() => history.goBack()} shrink>
      <div className={styles.ButtonContent}>
        <div className={styles.BackArrow}>{backArrow}</div>
        <span className={styles.BackLabel}>Back</span>
      </div>
    </SubtleButton>
  );
}
